import React from 'react';
import './App.css';
import './clinical-supervision/ClinicalSupervision.css'
import { AnimatePresence, motion } from 'framer-motion';
import Tracy from './Tracy.jpg';
import Mycha from './MychaPic.jpeg';
import Solmaz from './SolmazPic.jpeg';
import Yulia from './YuliaPic.jpg';
import Kajal from './Kajal.jpeg';
import Tracey from './Tracey M.jpeg';
import { tracy1, tracy2, solmaz1 } from './TextContent.json';
import { Link } from 'react-router-dom';


class About extends React.Component {
    render() {
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <div className="about-top-container">
                    <h1>
                        Welcome to Tall Tree Psychotherapy!
                    </h1>
                    <div className='about-paragraph'>
                        We are committed to providing a safe and inclusive space for all people, regardless of race, culture, gender, sexual identity, social status, religious affiliation, age, or disability.
                    </div><br></br>
                    <h1 className='full-heading t-page'>
                        Tracy Bertrim
                        <div>
                            <p className="no-margin">Virtual & In-Person Services</p>
                            <p className="no-margin">$180</p>
                            <p className="no-margin">tracy@talltreepsychotherapy.ca</p>
                        </div>
                    </h1>
                    <div className='t-stats'>
                        <div>
                            <p>Populations Served</p>
                            <ul>
                                <li>Children</li>
                                <li>Adolescents</li>
                                <li>Adults</li>
                            </ul>
                        </div>
                        <div>
                            <p>Therapy Formats</p>
                            <ul>
                                <li>Individual</li>
                                <li>Family</li>
                            </ul>
                        </div>
                        <div>
                            <p>Main Areas of Focus</p>
                            <ul>
                                <li>Anxiety, Phobias</li>
                                <li>ADHD</li>
                                <li>Trauma and PTSD</li>
                                <li>First Responders and Frontline Workers</li>
                            </ul>
                        </div>
                    </div>
                    <div className='twocol rev'>
                        <div>
                            <p>Tracy (she/her) is a Registered Psychotherapist with over 12 years of clinical experience
                                providing evidence-based therapy for adults, children, and adolescents across Ontario.
                                She specializes in supporting individuals with <b>ADHD, anxiety disorders, and trauma.</b> In
                                particular, Tracy has extensive experience supporting first responders and frontline
                                workers, including those experiencing operational stress injuries, moral injury,
                                compassion fatigue, and cumulative trauma. She brings a deep understanding of the
                                unique pressures, culture, and mental health needs within these roles.</p>
                            <p>Tracy has a strong interest in supporting individuals with ADHD, particularly women,
                                whose symptoms are often overlooked or misunderstood. With extensive clinical
                                experience, she helps clients navigate challenges related to emotional regulation,
                                executive functioning, overwhelm, and self-esteem. Tracy recognizes that ADHD in
                                women can present differently—often shaped by masking, burnout, and years of
                                feeling “not good enough.” She provides a compassionate, validating space while
                                integrating evidence-based approaches to help clients better understand their brains,
                                build practical strategies, and develop a more empowered sense of self.</p>
                            <p>Tracy offers a warm, non-judgmental space where clients can explore their thoughts,
                                emotions, and experiences safely. She understands that seeking therapy can feel
                                overwhelming and works collaboratively with clients to build insight, resilience, and
                                practical coping strategies. Her approach is integrative and tailored to each individual,
                                drawing from trauma-informed therapy, Cognitive Behavioral Therapy (CBT),
                                Dialectical Behaviour Therapy (DBT), Acceptance and Commitment Therapy (ACT), and
                                mindfulness-based interventions.</p>
                            <p>In addition to her clinical work, Tracy meets the CRPO requirements for clinical
                                supervision and provides supervision to psychotherapy and social work students, as well
                                as registered professionals seeking supervised practice hours</p>
                        </div>
                        <img src={Tracy} className='twoimg port' />
                    </div>
                    <h1 className='full-heading t-page'>
                        Solmaz Barghgir
                        <div>
                            <p className="no-margin">Virtual Services</p>
                            <p className="no-margin">$150</p>
                            <p className="no-margin">solmaz@talltreepsychotherapy.ca</p>
                        </div>
                    </h1>
                    <div className='t-stats'>
                        <div>
                            <p>Populations Served</p>
                            <ul>
                                <li>Adolescents</li>
                                <li>Adults</li>
                            </ul>
                        </div>
                        <div>
                            <p>Therapy Formats</p>
                            <ul>
                                <li>Individual</li>
                                <li>Family</li>
                            </ul>
                        </div>
                        <div>
                            <p>Main Areas of Focus</p>
                            <ul>
                                <li>Anxiety</li>
                                <li>Relationship Issues</li>
                                <li>Self Esteem</li>
                            </ul>
                        </div>
                    </div>
                    <div className='twocol'>
                        <img src={Solmaz} className='twoimg port' />
                        <div>
                            <p>{solmaz1}</p>
                            <p>Recognizing the importance of collaboration, Solmaz believes in the shared responsibility
                                between counsellor and client in the therapeutic journey. <i>Solmaz tailors integrated interventions
                                    to address individual needs using diverse therapeutic approaches</i> from a range of evidence-
                                based modalities, including Art Therapy, Attachment-based Coaching, Cognitive Behavioural
                                (CBT), Emotionally Focused, Multicultural, Narrative, and Solution-Focused Brief (SFBT) to
                                tailor treatment plans that would effectively soothe clients' needs.</p>
                        </div>
                    </div>
                    <h1 className='full-heading t-page'>
                        Yulia Saveliev
                        <div>
                            <p className="no-margin">Virtual Services</p>
                            <p className="no-margin">$150</p>
                            <p className="no-margin">yulia@talltreepsychotherapy.ca</p>
                        </div>
                    </h1>
                    <div className='t-stats'>
                        <div>
                            <p>Populations Served</p>
                            <ul>
                                <li>Adults</li>
                            </ul>
                        </div>
                        <div>
                            <p>Therapy Formats</p>
                            <ul>
                                <li>Individual</li>
                            </ul>
                        </div>
                        <div>
                            <p>Main Areas of Focus</p>
                            <ul>
                                <li>ADHD</li>
                                <li>Depression</li>
                                <li>Anxiety</li>
                                <li>Emotion Regulation</li>
                                <li>Relationship Issues</li>
                            </ul>
                        </div>
                    </div>
                    <div className='twocol'>
                        <img src={Yulia} className='twoimg port' />
                        <div>
                            <p>
                                Yulia (she/her) is a registered psychotherapist with the College of Registered Psychotherapists of Ontario. Yulia is a compassionate psychotherapist with over 10 years of experience in the mental health field, dedicated to helping individuals from diverse backgrounds find balance in their lives. Yulia values diversity and inclusion, recognizing that each person's unique experiences and identity play a significant role in their journey. Understanding that life is often filled with challenges, Yulia believes that embracing struggle is an essential part of personal growth. She specializes in supporting clients with ADHD, depression, anxiety, emotion regulation, and relationship issues.</p>
                            <p>Using an eclectic approach, Yulia draws from modalities including Dialectical Behavior Therapy (DBT), Cognitive Behavioral Therapy (CBT), Narrative Therapy, and Motivational Interviewing, tailoring her approach to each client's unique needs. By fostering resilience, inclusivity, and a sense of purpose, Yulia works collaboratively with clients to overcome obstacles and move toward their goals, navigating life’s complexities and creating lasting, meaningful change.</p>
                        </div>
                    </div>
                    <h1 className='full-heading t-page'>
                        Kajal Patel
                        <div>
                            <p className="no-margin">Virtual Services</p>
                            <p className="no-margin">$150</p>
                            <p className="no-margin">kajal@talltreepsychotherapy.ca</p>
                        </div>
                    </h1>
                    <div className='t-stats'>
                        <div>
                            <p>Populations Served</p>
                            <ul>
                                <li>Children</li>
                                <li>Adolescents</li>
                                <li>Adults</li>
                            </ul>
                        </div>
                        <div>
                            <p>Therapy Formats</p>
                            <ul>
                                <li>Individual</li>
                                <li>Family</li>
                            </ul>
                        </div>
                        <div>
                            <p>Main Areas of Focus</p>
                            <ul>
                                <li>Anxiety</li>
                                <li>Depression</li>
                                <li>Emotion Regulation</li>
                                <li>School Concerns</li>
                            </ul>
                        </div>
                    </div>
                    <div className='twocol rev'>
                        <div>
                            <p>Kajal (she/her) is a registered social worker who completed her Master of Social Work at Wilfrid Laurier University and previously completed her Master of Education in Developmental Psychology. Kajal has a background working with children and youth and most recently with adults experiencing mental health and addictions. Kajal believes in a collaborative, client-focused practice which involves working with the client to recognize their needs and goals. Kajal’s goal is to provide holistic counselling to individuals, children and families seeking mental health support.</p>
                        </div>
                        <img src={Kajal} className='twoimg port' />
                    </div>
                    <h1 className='full-heading t-page'>
                        Tracey McKavanagh
                        <div>
                            <p className="no-margin">Virtual Services</p>
                            <p className="no-margin">$150</p>
                            <p className="no-margin">traceym@talltreepsychotherapy.ca</p>
                        </div>
                    </h1>
                    <div className='t-stats'>
                        <div>
                            <p>Populations Served</p>
                            <ul>
                                <li>Adults</li>
                                <li>Adolescents</li>
                            </ul>
                        </div>
                        <div>
                            <p>Therapy Formats</p>
                            <ul>
                                <li>Individual</li>
                            </ul>
                        </div>
                        <div>
                            <p>Main Areas of Focus</p>
                            <ul>
                                <li>Anxiety</li>
                                <li>Depression</li>
                                <li>PTSD and Trauma</li>
                            </ul>
                        </div>
                    </div>
                    <div className='twocol'>
                        <img src={Tracey} className='twoimg port' />
                        <div>
                            <p>Life can feel overwhelming at times, but you don't have to navigate it alone. Tracey McKavanagh (she/her) is a Registered Psychotherapist (Qualifying) who believes that therapy is a space where you can work collaboratively with the therapist, not just to survive, but to thrive.</p>
                            <p>She takes an integrative approach to therapy, drawing from a variety of modalities to tailor treatment to your unique needs. No two people are alike, and she believes that therapy should reflect that. Tracey works with individual adults experiencing various needs and concerns, including anxiety, depression, PTSD and trauma, ADHD, and life transitions.</p>
                            <p>Tracey views the therapeutic process as a shared journey, one in which you can explore who you are, where you've been, and where you're headed through self-compassion and understanding. Whether you're just beginning therapy or returning to it, she is there to support your growth and self-discovery.</p>
                            <p>Tracey’s own journey in life and experiences working with excellent therapists have inspired her to become a psychotherapist, and she wants to share with and support others as they begin, change, or continue on their own paths. Reaching out for help takes courage. If you're ready, she would be honoured to walk alongside you on your journey toward healing and growth.</p>
                        </div>
                    </div>
                    <h1 className='full-heading t-page'>
                        Mycha Haughton-Lewis
                        <div>
                            <p className="no-margin">Virtual Services</p>
                            <p className="no-margin">$150</p>
                            <p className="no-margin">mycha@talltreepsychotherapy.ca</p>
                        </div>
                    </h1>
                    <div className='t-stats'>
                        <div>
                            <p>Populations Served</p>
                            <ul>
                                <li>Adolescents</li>
                                <li>Adults</li>
                            </ul>
                        </div>
                        <div>
                            <p>Therapy Formats</p>
                            <ul>
                                <li>Individual</li>
                                <li>Couples</li>
                            </ul>
                        </div>
                        <div>
                            <p>Main Areas of Focus</p>
                            <ul>
                                <li>Anxiety</li>
                                <li>Self Identity</li>
                                <li>ADHD</li>
                                <li>OCD</li>
                                <li>BPD</li>
                            </ul>
                        </div>
                    </div>
                    <div className='twocol rev'>
                        <div>
                            <p>Mycha (she/her) is a registered psychotherapist (qualifying) with over a year of clinical
                                experience who has worked with individuals with diverse concerns. Mycha ensures she
                                provides a welcoming and safe environment for clients to explore their thoughts and
                                concerns from a non-judgmental approach. Mycha believes the client is the expert of
                                their own life which means the client plays a significant role in the therapeutic process.
                                In addition, Mycha&#39;s approach is client-centered, ensuring a collaborative relationship
                                between client and therapist. Mycha is aware that the therapeutic process is different for
                                each client. She incorporates evidence-based treatments such as Acceptance and
                                Commitment Therapy (ACT), Dialectical Behavioural Therapy (DBT) and Interpersonal
                                and Social Rhythm Therapy (IPSRT) to provide a treatment plan based on the client&#39;s
                                treatment goals.</p>
                        </div>
                        <img src={Mycha} className='twoimg port' />
                    </div>
                </div>
                <br /><br />
                <div className="link-button"><Link to='/psychotherapy-services/contact'>Interested in services? Click here</Link></div>
            </motion.div>
        )
    }
}

export default About;